module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAM1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjBUbJAAAAEHRSTlMAAgwNEBkaHDhlgJfJ2PHyXFaKdQAAAJJJREFUeNrtzlkKwkAURcHnGI1T9r9aJYTQDX6qF6FqA+dUAQAAAP9ofw73r9MY7k/Jg7kfPFj6sYO1Hzpo+pGDbdtPHGwukwMHDhw4cODAgQMHDhy8dXx0A/fhx/3Dre+f9PX19fX19fX19fW/ZhfuV43hfncQ6TcHof56EOsvB8H+fBDtvw7C/aqhAAAAAD7mCSa8NqEHJVaLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/nextArrowIos.jpg
// module id = 9
// module chunks = 1